// extracted by mini-css-extract-plugin
module.exports = {"introText":"AwaitingConfirmation_introText__36RBO","title":"AwaitingConfirmation_title__o-iQA"};